import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "./stdInvoice.css";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../../../store/redux/student_reducer.js";
import { useSnackbar } from "notistack";
import axios from "axios";
import Logo from "../logo/Manga_Cons _Logo2.png";
import Monnify from "monnify-js";

let studentData;

const Invioce = ({ setLoading, SetHandlePayment, hasPaidForSession }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { info } = useSelector(
    (state) => state.studentFunction.queue.studentData,
  );

  const invoiceRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current || null,
  });

  /*
   * =========================================================
   * CURRENT SESSION / INVOICE
   * =========================================================
   */

  const currentSession = info?.academicInfo?.pressent_session;

  const tuitionFees = info?.financialRecords?.tuitionFees || [];

  const currentInvoice = tuitionFees.find(
    (invoice) => invoice?.session === currentSession,
  );

  const hasCurrentSessionPaid =
    currentInvoice?.paymentStatus === "Paid";

  /*
   * =========================================================
   * STUDENT INFORMATION
   * =========================================================
   */

  const email = info?.contactInfo?.email;

  const phone_number = info?.contactInfo?.phone_number;

  const name = `${info?.personalInfo?.first_Name || ""} ${
    info?.personalInfo?.sur_Name || ""
  } ${info?.personalInfo?.other_Name || ""}`.trim();

  /*
   * =========================================================
   * UPDATE PAYMENT
   * =========================================================
   */

  const makePayment = async (paymentResponse) => {
    const adm = info?.admission_number;

    const encodedId = encodeURIComponent(adm);

    const data = {
      session: currentSession,
      amount: paymentResponse?.amount,
      charged_amount: paymentResponse?.amount,
      paymentStatus: "Paid",
      transactionId: paymentResponse?.transactionReference,
      reference_number: paymentResponse?.paymentReference,
      paymentDate: new Date().toISOString(),
    };

    setLoading(true);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/registration_fee/paid/${encodedId}`,
        data,
      );

      studentData = response.data;

      console.log("StudentData:", response);

      dispatch(DispatchStudentData());

      enqueueSnackbar("Registration completed successfully!", {
        variant: "success",
        autoHideDuration: 3000,
        ContentProps: {
          style: {
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
      });

      SetHandlePayment(true);
    } catch (err) {
      console.log(err);

      enqueueSnackbar(
        err?.response?.data?.message ||
          "Payment was successful, but the payment record could not be updated.",
        {
          variant: "error",
          autoHideDuration: 4000,
        },
      );
    } finally {
      setLoading(false);
    }
  };

  const DispatchStudentData = () => async (dispatch) => {
    try {
      dispatch(Action.startStudentAction({ studentData }));
    } catch (error) {
      console.log(error);
    }
  };

  /*
   * =========================================================
   * MONNIFY PAYMENT
   * =========================================================
   */

  function RegPaymentBtn() {
    const pay = () => {
      const monnify = new Monnify(
        `${process.env.REACT_APP_PAYMENTGATEWAY_API_KEY}`,
        `${process.env.REACT_APP_MY_CONTRACT_CODE}`,
      );

      monnify.initializePayment({
        amount: 250000,
        currency: "NGN",
        reference: new Date().getTime(),
        customerFullName: name,
        customerEmail: email,
        paymentDescription: "Payment for Registration fee",

        metadata: {
          admission_number: `${info?.admission_number || ""}`,
          full_name: `${name}`,
          email: `${email || ""}`,
          phone_number: `${phone_number || ""}`,
          session: `${currentSession || ""}`,
        },

        onLoadStart: () => {
          console.log("Monnify SDK loading started");
          setLoading(true);
        },

        onLoadComplete: () => {
          console.log("Monnify SDK is ready");
          setLoading(false);
        },

        onComplete: (response) => {
          setLoading(false);

          console.log("Transaction complete:", response);

          if (response?.paymentStatus === "PAID") {
            makePayment(response);
          } else {
            enqueueSnackbar("Payment was not completed.", {
              variant: "warning",
              autoHideDuration: 4000,
            });
          }
        },

        onClose: (response) => {
          setLoading(false);

          console.log("Payment modal closed:", response);
        },
      });
    };

    return (
      <button
        type="button"
        className="payment-button"
        onClick={pay}
      >
        <span>Pay ₦250,000</span>
        <span className="payment-arrow">→</span>
      </button>
    );
  }

  /*
   * =========================================================
   * INVOICE
   * =========================================================
   */

  return (
    <div className="fx-cl space3">
      <div ref={invoiceRef} className="invoice flex-container">
        {/* First Container */}
        <div className="invoice-first-container">
          <div className="invoice-left-side fx-ac space2">
            <figure className="invoiceLogo">
              <img src={Logo} alt="logo" />
            </figure>

            <div className="fx-cl space1">
              {hasCurrentSessionPaid ? (
                <h1>Invoice Paid Successfully</h1>
              ) : (
                <h1>Bursar Office</h1>
              )}

              <p>PAYMENT INVOICE SCHEDULES</p>
            </div>
          </div>

          <div className="invoice-right-side fx-cl space1">
            <p>Manga College of Nursing Sciences</p>
            <p>No. 2 Zuru-Kontagora Road, Amanawa Area</p>
            <p>Zuru LGA, Kebbi State</p>
          </div>
        </div>

        {/* Second Container */}
        <div className="invoice-second-container fx-jb space3">
          <div className="invoice-inner-div">
            <div className="fx-cl space1">
              <h3>Invoice Details</h3>

              <div className="fx-cl">
                <p>
                  <strong>ReferenceID (RRR):</strong>{" "}
                  {currentInvoice?.transactionId || "Not generated"}
                </p>

                <p>
                  <strong>Status:</strong>{" "}
                  {hasCurrentSessionPaid
                    ? "Invoice Paid"
                    : "Un-Paid Invoice"}
                </p>

                <p>
                  <strong>Description:</strong> Academic Tuitions
                  Registration
                </p>

                <p>
                  <strong>Session:</strong>{" "}
                  {info?.academicInfo?.state?.pressent_session}
                </p>

                <p>
                  <strong>Level:</strong>{" "}
                  {info?.academicInfo?.state?.level}
                </p>
              </div>
            </div>
          </div>

          <div className="invoice-inner-div">
            <div className="fx-cl space1">
              <h3>Billed to</h3>

              <div className="fx-cl">
                <p>
                  <strong>Name: </strong>
                  {info?.personalInfo?.first_Name +
                    " " +
                    info?.personalInfo?.sur_Name +
                    " " +
                    info?.personalInfo?.other_Name}
                </p>

                <p>
                  <strong>Adm number:</strong>{" "}
                  {info?.admission_number ||
                    info?.academicInfo?.admission_number}
                </p>

                <p>
                  <strong>Programm:</strong>{" "}
                  {info?.personalInfo?.programme_of_study}
                </p>

                <p>
                  <strong>State:</strong>{" "}
                  {
                    info?.personalInfo?.permanent_home_address
                      ?.State_of_origin
                  }
                </p>

                <p>
                  <strong>Email:</strong>{" "}
                  {info?.contactInfo?.email}
                </p>

                <p>
                  <strong>Phone No.:</strong> +234
                  {info?.contactInfo?.phone_number}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Third Container */}
        <div className="invoice-third-container fx-cl space3">
          <div className="fx-cl">
            <h3>Payment details</h3>
            <p>Student registration fees</p>
          </div>

          <table className="invoiceTable">
            <thead style={{ textAlign: "left" }}>
              <tr>
                <th>Serial No.</th>
                <th>Items</th>
                <th>Discription</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              <h2>Service fees</h2>

              <tr>
                <td>02</td>
                <td>Maintenance</td>
                <td>Reg fee</td>
                <td>N20,000</td>
              </tr>

              <tr>
                <td>04</td>
                <td>ICT</td>
                <td>Reg fee</td>
                <td>N10,000</td>
              </tr>

              <tr>
                <td>07</td>
                <td>Laboratory</td>
                <td>Reg fee</td>
                <td>N20,000</td>
              </tr>

              <br />

              <h2>Portal access fees</h2>

              <tr>
                <td>01</td>
                <td>Portal Access Fee</td>
                <td>Reg fee</td>
                <td>N10,000</td>
              </tr>

              <tr>
                <td>02</td>
                <td>UP Charges</td>
                <td>Reg fee</td>
                <td>N0.00</td>
              </tr>

              <br />

              <h2>Tuition fees</h2>

              <tr>
                <td>01</td>
                <td>Library</td>
                <td>Reg fee</td>
                <td>N20,000</td>
              </tr>

              <tr>
                <td>02</td>
                <td>Examination</td>
                <td>Reg fee</td>
                <td>N20,000</td>
              </tr>

              <tr>
                <td>03</td>
                <td>Accreditation</td>
                <td>Reg fee</td>
                <td>N150,000</td>
              </tr>

              <tr>
                <td></td>
                <td>TOTAL</td>
                <td>-</td>
                <td>N250,000</td>
              </tr>
            </tbody>
          </table>

          {hasCurrentSessionPaid ? (
            <ul style={{ listStyle: "disc" }}>
              <em>Distribution:</em>
              <li>Head of Department</li>
              <li>Registrar</li>
              <li>Student's Copy</li>
            </ul>
          ) : (
            <div className="invoiceBottom fx-cl fx-jc space2">
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#f00395",
                }}
              >
                Kindly note that, payment made is non-refundable. Read
                Return, Refund and Cancellation Policy
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="fx-jb">
        {hasCurrentSessionPaid ? (
          <button
            className="printInvoice"
            type="button"
            onClick={handlePrint}
          >
            Print invoice
          </button>
        ) : (
          <div className="fx-cl space2">
            <span>
              Payment method: <strong>Monnify</strong>
            </span>

            <span>
              Amount: <strong>₦250,000</strong>
            </span>

            <RegPaymentBtn />
          </div>
        )}
      </div>
    </div>
  );
};

export default Invioce;